import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import uniqueId from 'lodash.uniqueid';

// Rendered as a real <button> so it is focusable and operable with
// Enter/Space without any extra key handling (WCAG 2.1.1 / 4.1.2, PM-18410).
// Previously a bare <div onClick>, duplicated in TableCore and ReportsTable.
const ResetColumnsButton = styled.button`
    padding: 12px;
    display: inline-block;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.accent};
    background: none;
    border: none;
    font: inherit;
    line-height: 1;
    &:hover {
        opacity: 0.75;
    }
    &:disabled {
        cursor: default;
    }
`;

/**
 * "Reset columns" control shared by TableCore and ReportsTableWithData.
 * Visible only once custom widths exist (PM-18404).
 */
const ResetColumnsControl = ({ visible, onReset }) => {
    const { t } = useTranslation();
    const btnId = useRef(uniqueId('reset-cols-')).current;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const label = t('tableSettings$resetColumns');

    return (
        <>
            {/* Always in DOM so the tooltip target is stable; hidden until custom widths exist. */}
            <ResetColumnsButton
                type="button"
                id={btnId}
                onClick={visible ? onReset : undefined}
                disabled={!visible}
                aria-label={label}
                style={{ visibility: visible ? 'visible' : 'hidden' }}
            >
                <FontAwesomeIcon icon="sync" />
            </ResetColumnsButton>
            <Tooltip
                target={btnId}
                isOpen={tooltipOpen && visible}
                toggle={() => setTooltipOpen((o) => !o)}
            >
                {label}
            </Tooltip>
        </>
    );
};

export default ResetColumnsControl;
